import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type {
  Assignee,
  InstitutionMember,
} from '@backrs_ui/grow-ui/src/redux/coachingDashboard/coachingDashboard.types';
import { personName } from '@backrs_ui/grow-ui/src/utils/personName';

import type { RosterTab } from './coachingDashboardTabs';

type Member = Assignee | InstitutionMember;

type RosterView = Readonly<{
  /** Null when the roster tabs are not shown to this viewer. */
  activeTab: RosterTab | null;
  tabLabel: string | null;
  members: readonly Member[];
  totalCount: number;
  searchValue: string;
}>;

export const useAgentContext = ({
  activeTab,
  tabLabel,
  members,
  totalCount,
  searchValue,
}: RosterView) => {
  useRegisterAgentContext(activeTab && tabLabel ? { kind: 'tab', title: tabLabel } : null);

  useRegisterAgentContext(
    members.length
      ? {
          kind: 'list',
          description: 'The roster rows currently visible on the coaching dashboard.',
          data: {
            active_tab: activeTab,
            search: searchValue || null,
            showing: members.length,
            total_count: totalCount,
            members: members.map((member) => ({
              user_id: member.id,
              name: personName(member),
              is_verified: member.is_verified ?? null,
            })),
          },
        }
      : null,
  );
};
